<glxy-form-field required="true">
  <glxy-label>
    {{ 'AUTOMATIONS.COMMON.NUMBER' | translate }}
  </glxy-label>
  <input [formControl]="numberInputControl" matInput type="number" />
  <glxy-error *ngIf="numberInputControl.invalid && numberInputControl.dirty">
    {{ 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.ERRORS.NUMBER_NOT_POSITIVE' | translate }}
  </glxy-error>
</glxy-form-field>
